angular.module('octopusApp.infrastructure').directive('octoBarChart', function () {
    return {
        restrict: 'E',
        scope: {
            reportData: "="
        },
        template: '<div class="chart project-deployments" style="width: 200px;height: 90px"></div>',
        replace: true,
        transclude: true,

        link: function ($scope, element) {
            $scope.$watch('reportData', function (reportData) {
                if (!reportData) {
                    return;
                }
                var dataSeries = reportData.Series[0].Data;
                var barPadding = 1;
                var units = element.height() / Math.max.apply(Math, dataSeries);
                d3.select(element[0])
                    .append("svg")
                    .selectAll("rect")
                    .data(dataSeries)
                    .enter()
                    .append("rect")
                    .attr("class", "bar")
                    .attr("x", function (d, i) {
                        return i * (element.width() / dataSeries.length);
                    })
                    .attr("y", function (d) {
                        return element.height() - units * d;
                    })
                    .attr("width", element.width() / dataSeries.length - barPadding)
                    .attr("height", function (d) {
                        return units * d;
                    });
            });
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/octo_bar_chart.js
// module id = 3746325533402694
// module chunks = 1